import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { ArrowLeft, PenLine } from "lucide-react";

export default function JournalPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Journal | ALIGN&bull;</title>
        <meta name="description" content="Articles, reflections, and insights from ALIGN• — on psychology, neurodivergence, parenting, and everyday life." />
      </Helmet>

      <div className="min-h-screen" style={{ backgroundColor: "#F7F5F0" }} data-testid="journal-page">
        <header className="bg-white/70 backdrop-blur-xl border-b border-white/20 sticky top-0 z-40">
          <div className="max-w-5xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
            <div className="flex items-center gap-4">
              <button onClick={() => navigate("/")} className="text-[#5C635A] hover:text-[#4A6741] transition-colors">
                <ArrowLeft size={18} />
              </button>
              <button onClick={() => navigate("/")} className="font-['Cormorant_Garamond'] text-2xl font-light tracking-tight text-[#1A1C19] hover:text-[#4A6741] transition-colors">
                ALIGN<span className="text-[#4A6741]">&bull;</span>
              </button>
            </div>
            <p className="text-[#5C635A] font-['Manrope'] text-xs uppercase tracking-widest font-medium">Journal</p>
          </div>
        </header>

        <main className="max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center mb-16">
            <p className="text-xs uppercase tracking-[0.3em] font-medium text-[#4A6741] mb-6">Journal</p>
            <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-light tracking-tight text-[#1A1C19] mb-6">
              Reflections &amp; Writing
            </h1>
            <p className="text-lg font-light text-[#5C635A] max-w-2xl mx-auto">
              Thoughts on psychology, neurodivergence, parenting, and the space
              between understanding and everyday life.
            </p>
          </motion.div>

          {/* Empty state */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="glass-card p-16 text-center max-w-2xl mx-auto"
            data-testid="journal-coming-soon"
          >
            <div className="w-14 h-14 rounded-2xl bg-[#4A6741]/10 flex items-center justify-center mx-auto mb-6">
              <PenLine size={24} className="text-[#4A6741]" strokeWidth={1.5} />
            </div>
            <h2 className="font-['Cormorant_Garamond'] text-2xl font-normal text-[#1A1C19] mb-3">
              Coming Soon
            </h2>
            <p className="text-sm font-light text-[#5C635A] max-w-md mx-auto mb-6">
              We're putting pen to paper. Articles and reflections will appear
              here as the practice takes shape. Join our waiting list to be
              notified when new writing is published.
            </p>
            <button onClick={() => navigate("/")} className="btn-pill-outline text-[11px]">
              Join Waiting List
            </button>
          </motion.div>

          <div className="mt-16 pt-8 border-t border-[#EAE6DF] text-center">
            <button onClick={() => navigate("/")} className="text-xs text-[#5C635A] hover:text-[#4A6741] transition-colors inline-flex items-center gap-2">
              <ArrowLeft size={12} /> Back to ALIGN&bull;
            </button>
          </div>
        </main>
      </div>
    </>
  );
}
